import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Chapter } from "./Reveal";
import { useContent, useSectionMeta } from "../content/ContentContext";

export const Story = () => {
  const { SITE } = useContent();
  const meta = useSectionMeta("story");
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: imgRef, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="story" className="relative py-24 md:py-36 overflow-hidden" data-testid="story-section">
      <div className="absolute -left-40 top-1/3 w-[480px] h-[480px] rounded-full bg-gold/[0.05] blur-[140px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-5 order-2 lg:order-1">
            <div ref={imgRef} className="relative overflow-hidden rounded-sm aspect-[4/5] lg:aspect-[3/4]">
              <motion.img
                src={SITE.story.image}
                alt="The family gathered around the dinner table"
                style={{ y, scale: 1.14 }}
                className="w-full h-full object-cover img-cinematic"
                data-testid="story-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/50 via-transparent to-transparent" />
            </div>
            <p className="text-[10px] tracking-[0.3em] uppercase text-smoke mt-4">
              {SITE.story.caption}
            </p>
          </Reveal>

          <div className="lg:col-span-7 order-1 lg:order-2 lg:pl-6">
            <Reveal>
              <Chapter number={meta.number} label={meta.label} id="story" />
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight" data-testid="story-heading">
                THE <span className="italic text-gold-light">STORY</span>
              </h2>
            </Reveal>
            {SITE.story.paras.map((p, i) => (
              <Reveal key={i} delay={0.12 + i * 0.1}>
                <p
                  className={`mt-7 leading-relaxed ${
                    i === 0
                      ? "font-quote italic text-xl md:text-2xl text-ivory/90"
                      : "text-sm md:text-base text-smoke max-w-xl"
                  }`}
                  data-testid={`story-paragraph-${i}`}
                >
                  {p}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
